import GetTokenMicrosoftRequestModelBase from '../_generated/modelBases/get-token-microsoft-request-model-base';

export default class GetTokenMicrosoftRequestModel extends GetTokenMicrosoftRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
